import { Location } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

import { NavMenuItem } from './_models/nav-menu-item.model';

@Pipe({
  name: 'navItemActive',
  pure: true
})
export class NavItemActivePipe implements PipeTransform {
  constructor(private readonly location: Location) {}

  transform(nav: NavMenuItem, currentPath?: string | null): boolean {
    if (nav.children) {
      if (this.location.isCurrentPathEqualTo(nav.path)) {
        return true;
      }

      const activeChildren = nav.children.map(route =>
        this.location.isCurrentPathEqualTo(route.path)
      );
      if (activeChildren.some(active => active)) {
        return true;
      }

      if (currentPath && currentPath.startsWith(nav.path)) {
        return true;
      }
    }

    return false;
  }
}
